module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/daaridna-avatar-1e070a9832832d2621e298a417b61a76.jpg";